/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";

export default function DisclaimerPage() {
  return (
    <LegalPageLayout
      testid="page-disclaimer"
      eyebrow="— Legal"
      title="Health & Wellness Disclaimer"
      subtitle="DONiTSH!T is an educational wellness ecosystem — not a medical service."
      lastUpdated="August 2026"
    >
      <h2>Educational Only</h2>
      <p>
        All content on the DONiTSH!T website and mobile applications —
        including editorial articles, the Wellness Hub, the Dosha Test,
        Ask Donny, and marketplace practitioner profiles — is provided
        for <strong>general wellness and educational purposes only</strong>.
      </p>

      <h2>Not Medical Advice</h2>
      <p>
        DONiTSH!T does not provide medical diagnosis, medical treatment,
        or clinical advice. Content on the Service is{" "}
        <strong>not a substitute</strong> for the professional judgment
        of a qualified physician, therapist, dietitian, or other
        licensed healthcare provider.
      </p>

      <h2>Ask Donny</h2>
      <p>
        Ask Donny is an AI wellness assistant that draws from
        DONiTSH!T's own library and can cite authoritative sources. Ask
        Donny may provide informational guidance and references. Ask
        Donny does not diagnose conditions, prescribe treatments, or
        replace individualized care from a licensed clinician. When Ask
        Donny cannot ground an answer in the DONiTSH!T library, it will
        indicate that it is providing general guidance.
      </p>

      <h2>Dosha Test</h2>
      <p>
        The Dosha Test is a self-reflective, Ayurveda-inspired tool that
        offers a lens for lifestyle personalization. It is not a
        diagnostic instrument and its results should not be used to make
        clinical decisions.
      </p>

      <h2>Before Making Health Decisions</h2>
      <p>
        Consult a qualified healthcare professional before starting a
        new fitness program, changing your diet, taking supplements,
        altering medication, or acting on any wellness recommendation —
        particularly if you are pregnant, nursing, managing a medical
        condition, taking prescription medication, or have a history of
        eating disorders or mental-health conditions.
      </p>

      <h2>Emergencies and Crisis</h2>
      <p>
        <strong>
          If you are experiencing a medical emergency, call your local
          emergency number immediately.
        </strong>{" "}
        If you are in mental-health crisis, please contact your local
        crisis line — country-specific resources are listed on our{" "}
        <Link to="/support">Support page</Link>.
      </p>

      <h2>Marketplace Practitioners</h2>
      <p>
        Practitioners and businesses in the DONiTSH!T Marketplace are
        independent third parties. DONiTSH!T does not verify individual
        clinical credentials beyond the listing information provided by
        each business, and does not guarantee outcomes. Any client
        relationship you enter with a marketplace practitioner is
        governed by that practitioner's own professional terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this disclaimer can be sent through the{" "}
        <Link to="/support">Support page</Link>.
      </p>
    </LegalPageLayout>
  );
}
